<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">签到记录</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="签到时间：">
            <el-date-picker
              v-model="startTime"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              :clearable="false"
              @change="changeBegin"
              placeholder="选择开始时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="endTime"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              :clearable="false"
              @change="changeEnd"
              placeholder="选择结束时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="签到人" prop="name">
            <el-input v-model="name" placeholder="请输入签到人"></el-input>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="search">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="55"
                :index="indexMethod"
              >
              </el-table-column>
              <el-table-column prop="createdate" label="签到时间">
              </el-table-column>
              <el-table-column prop="name" label="签到人"></el-table-column>
              <el-table-column
                prop="organizationName"
                label="所属部门"
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>
<script>
import { getSignList } from "@/request/api";
export default {
  action: "SignIn",
  controller: "UI",
  name: "SignIn",
  data() {
    return {
      startTime: "",
      endTime: "",
      name: "",
      tableData: [],
      size: 20,
      page: 1,
      total: 0,
    };
  },
  mounted: function() {
    this.search();
  },
  methods: {
    handleSizeChange(val) {
      this.size = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.search();
    },
    changeBegin() {
      if (this.startTime && this.endTime) {
        if (
          new Date(this.startTime).getTime() > new Date(this.endTime).getTime()
        ) {
          this.startTime = "";
          this.$message({
            type: "warning",
            message: "开始时间不能大于结束时间",
          });
        }
      }
    },
    changeEnd() {
      if (this.startTime && this.endTime) {
        if (
          new Date(this.startTime).getTime() > new Date(this.endTime).getTime()
        ) {
          this.endTime = "";
          this.$message({
            type: "warning",
            message: "开始时间不能大于结束时间",
          });
        }
      }
    },
    search() {
      let { startTime, endTime, name, size, page } = this;
      if (startTime) {
        if (!endTime) {
          this.$message({
            type: "warning",
            message: "请选择结束时间",
          });
          return;
        }
      } else {
        if (endTime) {
          this.$message({
            type: "warning",
            message: "请选择开始时间",
          });
          return;
        }
      }
      let params = {
        startTime,
        endTime,
        name,
        size,
        page,
      };
      getSignList({ data: params, baseUrl: global.$config.api.apiUrl }).then(
        (res) => {
          if (res.data) {
            this.tableData = res.data.records || [];
            this.total = res.data.total || 0;
          }
        }
      );
    },
    indexMethod(index) {
      return index + 1;
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    clearsearch() {
      this.startTime = "";
      this.endTime = "";
      this.name = "";
      this.page = 1;
      this.size = 20;
    },
  },
};
</script>

